module.exports = __webpack_public_path__ + "img/Barcode Icon - white.fb6762de.svg";